<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from 'axios';
import moment from 'moment';
import Swal from 'sweetalert2';
import Select2 from 'vue3-select2-component';
import "@vueform/multiselect/themes/default.css";
import { usePermissions } from '@/composables/usePermissions';
import { formatDateToWeb } from "@/helpers/date-functions.js";

//import DataTable from 'datatables.net-vue3';
require("@/assets/css/datatable.css");
export default {
  page: {
    title: "Order Information",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      title: "Order Information",
      items: [
        {
          text: "Orders",
          href: "/",
        },
      ],

      customer_order_info: [],
      customer_mandate_info: [],
      orderstatusList: [],
      listColor: [],
      customer_first_name: '',
      customer_last_name: '',
      customer_full_name: '',
      order_no: '',
      created_at: '',
      data_verification: '',
      call_verification: '',
      program_name: '',
      product_name: '',
      sku: '',
      price: '',
      order_status_name: '',
      order_status_id: '',
      front_nric: '',
      back_nric: '',
      program_fee: '',
      remarks: '',
      cancel_reason:'',
      namepernric:'',
      paymentLists:[],
      branchListPickup:[],
      loadingData:true,
      credit_check_result:'',
      payment_status_mandate:'',
      payment_status_upfront:'',
      mandate_status:'Not Paid',
      instantpay_status:'Not Paid',
      curlec_reference_no: '',
      payment_link:'',
      email_status: '',
      credit_check_request_by: '',
      credit_check_request_datetime: '',
      creditCheckNotActive: true,
      order_id:'',
      dob:'',
      customer_id : this.$route.params.cid,
      retry:0,
      net_salary:'',
      salary_range: '',
      pickup_store: '',
      temp_id: '',
      email_address:'',
      disableGeneratePaymentLink: true,
      disableSendEmail: true,
      credit_check: '',
      nric: '',
      delivery_address: '',
      pickup_store_address: '',
      order_for: '',
      straight_through: '',
      nric_num:'',
      dropoff_cust:'',
      dropoff_temp:'',
      pickup_branch:'',
      credit_check_real:'',
      branchList:'',
      pickupbranch:'',
      delivery_option:'',
      delivery_postcode:'',
      delivery_city:'',
      delivery_state:'',
      country:1,
      server_env: process.env.VUE_APP_SERVER,
      id_order:'',
      tenure: '',
      program_id:'',

      emailconfirm: true,
      buttonskudisable: true,

      has_house_delivery: 0,
      hash: '',
      UploadEPFLinkURL:'',
      securityDeposit: 0,
      knockOffAmount: 0,
      newlyMonthlyAmount: 0,
      upfrontPaymentDate: '',
    };
  },
  setup() {
        const permissions = usePermissions();
        
        return {
            permissions,
        };
    },
  methods: {
    format_date(value){
        if (value) {
            return moment(String(value)).format('YYYY-MM-DD HH:mm:ss')
        }
    },

    formatDateToWeb,

    getCreditCheck(order_id){
      axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.get(process.env.VUE_APP_API_BASEURL+'creditcheck/request/'+order_id)
        .then(response => {
            this.credit_check_real = response.data['0'].name;
          })
        .catch(error => {
            this.messageBag = [error.error];
        });
      // 
    },

    get_branch(){
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.get(process.env.VUE_APP_API_BASEURL+'branch/list/'+this.order_for)
        .then(response => {
            if (response) {
                this.branchList = response.data;
                console.log("this.branchList",this.branchList);
                const branchListmap = this.branchList.map((branchList) => {
                    return {
                        id: branchList.id,
                        text: branchList.name,
                    }
                    })
                this.branchList = branchListmap;
            } 
            else {
                this.messageBag = ['No record.'];
            }
        })
        .catch(error => {
            this.messageBag = [error.error];
        });
    },

    getBranchForDelivery(){
        axios.get(process.env.VUE_APP_API_BASEURL+'branch/pickup')
        .then(response => {
            if (response) {
              this.branchListPickup = response.data;
            } 
            else {
                this.messageBag = ['No record.'];
            }
        })
        .catch(error => {
            this.messageBag = [error.error];
        });
    },
    GetCollectionData(){
      
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_AR_API_BASEURL+'dashboard/customer/collection/'+this.$route.params.cid)
            .then(response => {
                if (response) {
                    this.Collection=response.data;
                    this.securityDeposit= this.Collection.security_deposit_amount;
                    this.knockOffAmount= this.Collection.knock_off_amount;
                    this.newlyMonthlyAmount = this.Collection.newly_monthly_amount;
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

    get_customer_by_id(){
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.get(process.env.VUE_APP_API_BASEURL+'customer/order_details/'+this.$route.params.cid)
        .then(response => {
          console.log('customer details here', response.data);
            if (response) {
                //this.loadingRoles=false;
                this.customer_order_info = response.data; 
                this.namepernric = this.customer_order_info[0].name_as_per_nric;
                this.customer_first_name = this.customer_order_info[0].first_name;
                this.customer_last_name = this.customer_order_info[0].last_name;
                this.customer_full_name = this.customer_order_info[0].first_name+' '+this.customer_order_info[0].last_name;
                this.order_no = this.customer_order_info[0].orderId;
                this.created_at = this.format_date(this.customer_order_info[0].created_at);
                this.data_verification = this.customer_order_info[0].data_verification;
                this.call_verification = this.customer_order_info[0].call_verification;
                this.program_name = this.customer_order_info[0].program_name;
                this.product_name = this.customer_order_info[0].product_name;
                this.sku = this.customer_order_info[0].sku;
                this.price = 'RM '+this.customer_order_info[0].price;
                this.order_status_name = this.customer_order_info[0].order_status_name;
                this.order_status_id = this.customer_order_info[0].order_status_id;
                this.front_nric = this.customer_order_info[0].front_nric;
                this.back_nric = this.customer_order_info[0].back_nric;
                this.program_fee = 'RM '+this.customer_order_info[0].program_fee;
                this.tenure = this.customer_order_info[0].tenure;
                this.remarks = this.customer_order_info[0].remarks;
                this.cancel_reason = this.customer_order_info[0].cancel_reason;
                this.credit_check_result = this.customer_order_info[0].credit_check_result;
                this.curlec_reference_no = this.customer_order_info[0].curlec_refno;
                this.credit_check_request_datetime = this.customer_order_info[0].credit_check_date;
                this.order_id = this.customer_order_info[0].order_id;
                this.pickup_store = this.customer_order_info[0].branch_id;
                this.temp_id = this.customer_order_info[0].temp_id;
                this.email_address = this.customer_order_info[0].email;
                this.credit_check = this.customer_order_info[0].credit_check;
                this.id_order = this.customer_order_info[0].id_order;
                // this.delivery_address = this.customer_order_info[0].delivery_address+',\n'+this.customer_order_info[0].delivery_postcode+', '+this.customer_order_info[0].delivery_city+', '+this.customer_order_info[0].delivery_state;
                this.delivery_address = this.customer_order_info[0].delivery_address;
                this.delivery_postcode = this.customer_order_info[0].delivery_postcode;
                this.delivery_city = this.customer_order_info[0].delivery_city;
                this.delivery_state = this.customer_order_info[0].delivery_state;
                this.delivery_state_id = this.customer_order_info[0].delivery_state_id;
                //this.pickup_store_address = "CompAsia Sunway Pyramid\nF1.82 , Jalan PJS 11/15, Bandar Sunway,\n47500 Petaling Jaya, Selangor";
                this.delivery_option = this.customer_order_info[0].delivery_option;
                this.straight_through = this.customer_order_info[0].straight_through;
                this.nric_num = this.customer_order_info[0].nric;
                this.dropoff_cust = this.customer_order_info[0].dropoff;
                this.referer_code = this.customer_order_info[0].referer_code;
                this.pickup_branch = this.customer_order_info[0].pickup_branch;


                this.getCreditCheck(this.order_id);


                if(this.customer_order_info[0].credit_check == 1 && this.order_status_id == 7){
                  this.disableGeneratePaymentLink = false;
                } else{
                  this.disableGeneratePaymentLink = true;
                }

                if(this.customer_order_info[0].credit_check == 3 || this.customer_order_info[0].credit_check == 0 ||this.order_status_id == '11') //order_status_id 11 = pending
                {
                  this.creditCheckNotActive = false;
                }

                if(this.order_status_id == 1||this.order_status_id == 2){
                  this.emailconfirm = false;
                }

                if(this.order_status_id == 10||this.order_status_id == 11||this.order_status_id == 6||this.order_status_id == 7||this.order_status_id == 12||this.order_status_id == 1){
                  this.buttonskudisable = false;
                }

                if(this.dropoff_cust == null){
                  this.get_customer_by_id_temp();  
                }
                // get payment history link
                axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                axios.get(process.env.VUE_APP_API_BASEURL+'getpaymenturldetail/'+this.order_id+'/'+this.$route.params.cid)
                .then(response => {
                  console.log("Payment Details",response.data);
                    if (response) {
                      this.payment_link = response.data.url;
                      this.credit_check_request_by = response.data.requested_by;
                      if(typeof response.data['url'] != 'undefined' && this.disableGeneratePaymentLink == false){
                        this.disableSendEmail = false;
                      }
                      if(response.data.send_to != null){
                      this.email_status = 'Sent';
                      } else {
                        this.email_status = 'Not Send'
                      }
                    } 
                    else {
                      this.messageBag = ['No record.'];
                    }
                })
                .catch(error => {
                    this.messageBag = [error.error];
                });

                //get customer detail
                axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                axios.get(process.env.VUE_APP_API_BASEURL+'customer/getdetail/'+this.temp_id+'?special=774nkfkdfyg2823nrweltnnskdfj12418flsbdjfnklf76487124')
                .then(response => {
                  console.log("Customer Details",response.data);
                    if (response) {
                      this.order_for = response.data.temporaryInfo['orderfor'];
                      this.program_id = response.data.order['program_id'];
                      this.getListOfColor(this.sku, this.program_id);
                      this.hash = response.data.temporaryInfo['hashvalue'];
                      this.urlUploadEPF();
                      this.get_branch();
                      if (typeof response.data.finance['net_salary'] !== 'undefined') {
                        this.net_salary = response.data.finance['net_salary'];
                        this.salary_range = response.data.finance['salary_range'];
                        this.nric = response.data.customer['nric'];
                        this.dob = response.data.customer['dob'];
                      }
                      this.has_house_delivery = response.data.program.has_house_delivery;
                    } 
                    else {
                      this.messageBag = ['No record.'];
                    }
                })
                .catch(error => {
                    this.messageBag = [error.error];
                });

                if(this.pickup_branch != null || this.pickup_branch != ''){
                  axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                  axios.get(process.env.VUE_APP_API_BASEURL+'branch/edit/'+this.pickup_branch)
                  .then(response => {
                      if (response) {
                          this.branch_info = response.data;
                          this.name = this.branch_info[0].name;
                         
                          this.address = this.branch_info[0].address;
                          this.city = this.branch_info[0].city;
                          this.postcode = this.branch_info[0].postcode;
                          this.state = this.branch_info[0].state;      
                          
                          this.pickup_store_address = this.branch_info[0].name+',\n'+this.branch_info[0].address+', '+this.branch_info[0].city+',\n'+this.branch_info[0].postcode+','+this.branch_info[0].state;
                      } 
                      else {
                          this.messageBag = ['No record.'];
                      }
                  })
                  .catch(error => {
                      this.messageBag = [error.error];
                  });
                }
          
                this.payment_status_mandate = this.customer_order_info[1].status;
                this.payment_status_upfront = this.customer_order_info[0].status;
            } 
            else {
                this.messageBag = ['No record.'];
            }
        })
        .catch(error => {
            this.messageBag = [error.error];
        });
    },

    getListOfColor(sku, program_id){
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.get(process.env.VUE_APP_API_BASEURL+'product/listcolor/'+program_id+'/'+sku)
        .then(response => {
            if (response) {
                this.listColor = response.data;
                console.log("List Color",this.listColor);
            } 
            else {
                this.messageBag = ['No record.'];
            }
        })
        .catch(error => {
            this.messageBag = [error.error];
        });
    },

    get_customer_mandate_sts(){
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.get(process.env.VUE_APP_API_BASEURL+'customer/customer_mandate_info/'+this.$route.params.cid)
        .then(response => {
          console.log("CUST Mandate Status",response);
            if (response) {
                this.customer_mandate_info = response.data; 
                if(this.customer_mandate_info.status == 1){
                  this.mandate_status = 'Paid';
                }
                else{
                  this.mandate_status = 'Not Paid';
                }
            } 
            else {
                console.log('customer_mandate_info : No response');
            }
        })
        .catch(error => {
            this.messageBag = [error.error];
        });
    },

    get_customer_instantpay_sts(){
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.get(process.env.VUE_APP_API_BASEURL+'customer/customer_instantpay_info/'+this.$route.params.cid)
        .then(response => {
          console.log("CUST Instantpay Status",response);
            if (response) {
                this.customer_instantpay_info = response.data; 
                if(this.customer_instantpay_info.status == 1){
                  this.instantpay_status = 'Paid';
                  this.upfrontPaymentDate = this.customer_instantpay_info.responseDateTimeInstantPay;
                }
                else{
                  this.instantpay_status = 'Not Paid';
                }
            } 
            else {
                console.log('customer_instantpay_info : No response');
            }
        })
        .catch(error => {
            this.messageBag = [error.error];
        });
    },

    update_customer_order(e)
    {
        this.ButtonSeen=true;
        e.preventDefault()
        
        const posting_ = {                
            data_verification: this.data_verification,
            call_verification: this.call_verification,
            order_status_id: this.order_status_id,
            remarks: this.remarks,
        };

        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.post(process.env.VUE_APP_API_BASEURL+'customer/update_customer_orders/'+this.$route.params.cid, posting_)
        .then(response => {
            if (response) {
                this.ButtonSeen=false; 
                alert(response.data.msj);  
                if(this.order_status_id == 7){
                  this.disableGeneratePaymentLink = false;  
                } else{
                  this.disableGeneratePaymentLink = true;
                }
                if(this.email_address != '' && this.disableGeneratePaymentLink == false){
                  this.disableSendEmail = false;
                } else {
                  this.disableSendEmail = true;
                }    
                
                this.get_customer_by_id();
            }
            else{
                this.ButtonSeen=false;
                console.log('tak ok');
            }
        });
    },
    update_customer_program_detail(e)
    {
        this.ButtonSeen=true;
        e.preventDefault()
        
        const posting_ = {                
            sku: this.sku,
            pickup_branch: this.pickup_store,
            program_code: this.order_for,
        };

        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.post(process.env.VUE_APP_API_BASEURL+'customer/update_customer_program_detail/'+this.$route.params.cid, posting_)
        .then(response => {
            if (response) {
                this.ButtonSeen=false; 
                alert(response.data.msj);  
                if(this.order_status_id == 7){
                  this.disableGeneratePaymentLink = false;  
                } else{
                  this.disableGeneratePaymentLink = true;
                }
                if(this.email_address != '' && this.disableGeneratePaymentLink == false){
                  this.disableSendEmail = false;
                } else {
                  this.disableSendEmail = true;
                }    
                
                this.get_customer_by_id();
            }
            else{
                this.ButtonSeen=false;
                console.log('tak ok');
            }
        });
    },
    update_ecom_delivery(e)
    {
        this.ButtonSeen=true;
        e.preventDefault()
        
        const posting_ = {                
            pickupbranch: this.pickupbranch,
            delivery_option: this.delivery_option,
            delivery_address: this.delivery_address,
            delivery_postcode: this.delivery_postcode,
            delivery_city: this.delivery_city,
            delivery_state: this.delivery_state_id,
            id_order: this.id_order,

        };

        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.post(process.env.VUE_APP_API_BASEURL+'customer/update_ecom_delivery/'+this.$route.params.cid, posting_)
        .then(response => {
            if (response) {
                this.ButtonSeen=false; 
                alert(response.data.msj);  
                if(this.order_status_id == 7){
                  this.disableGeneratePaymentLink = false;  
                } else{
                  this.disableGeneratePaymentLink = true;
                }
                if(this.email_address != '' && this.disableGeneratePaymentLink == false){
                  this.disableSendEmail = false;
                } else {
                  this.disableSendEmail = true;
                }    
                
                this.get_customer_by_id();
            }
            else{
                this.ButtonSeen=false;
                console.log('tak ok');
            }
        });
    },
    get_paymentlists(){
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.get(process.env.VUE_APP_API_BASEURL+'order/payment/'+this.$route.params.cid)
        .then(response => {
          //console.log("CUST DATA Detail",response);
            if (response) {
                this.loadingData=false;
                this.paymentLists = response.data;
                console.log("PAYMENT HISTORY",this.paymentLists);                  
            } 
            else {
                this.messageBag = ['No record.'];
            }
        })
        .catch(error => {
            this.messageBag = [error.error];
        });
    },

    generate_payment_link(){ 
      axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
      axios.get(process.env.VUE_APP_API_BASEURL+'getpaymentlink/'+this.order_id+'/'+this.$route.params.cid)
      .then(response => {
        console.log('payment link response', response);
          if (response) {
            this.loadingData=false;
            if(response.data.status == 'error'){
              this.messageBag = ['Fail'];
              Swal.fire({
                  title: 'Fail to generate payment link!',
                  icon: 'warn',
                  timer: 1000,
                  showConfirmButton: false,
              });
            } else {
                this.payment_link = response.data[0];
                if(this.payment_link != '' && this.disableGeneratePaymentLink == false && this.email_address != ''){
                  this.disableSendEmail = false;
                } else {
                  this.disableSendEmail = true;
                }
                console.log("Payment Link",this.payment_link); 
                Swal.fire({
                  title: 'Payment link generated!',
                  icon: 'success',
                  timer: 1000,
                  showConfirmButton: false,
              });
            }
          }  
      })
      .catch(error => {
          this.messageBag = [error.error];
      }); 
    },

    send_email(){
      axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
      axios.get(process.env.VUE_APP_API_BASEURL+'sendpaymenturl/'+this.order_id+'/'+this.$route.params.cid)
      .then(response => {
        console.log('send email response', response.data);
          if (response) {
              this.loadingData=false;
              if(response.data.status != 'error'){
                this.email_status = 'Sent';
                Swal.fire({
                  title: `Email sent to ${this.email_address}!`,
                  icon: 'success',
                  timer: 2050,
                  showConfirmButton: false,
                });
              } else {
                this.email_status = 'Not Send';
                Swal.fire({
                  title: 'Failed to send email!',
                  icon: 'warning',
                  timer: 2050,
                  showConfirmButton: false,
              });
              }              
          } 
          else {
              this.messageBag = ['Error'];
          }
      })
      .catch(error => {
          this.messageBag = [error.error];
      }); 
    },
    send_email_customer(){
      axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
      axios.get(process.env.VUE_APP_API_BASEURL+'sendpaymenturl/'+this.order_id+'/'+this.$route.params.cid)
      .then(response => {
        console.log('send email response', response.data);
          if (response) {
              this.loadingData=false;
              if(response.data.status != 'error'){
                this.email_status = 'Sent';
                Swal.fire({
                  title: `Email sent to ${this.email_address}!`,
                  icon: 'success',
                  showConfirmButton: false,
                });
              } else {
                this.email_status = 'Not Send';
                Swal.fire({
                  title: 'Failed to send email!',
                  icon: 'warning',
                  showConfirmButton: false,
              });
              }              
          } 
          else {
              this.messageBag = ['Error'];
          }
      })
      .catch(error => {
          this.messageBag = [error.error];
      }); 
    },
    send_email_success_cust(){

      Swal.fire({
        title: 'Are you sure want to add cron for customer success?',
        icon: 'warning',
        showConfirmButton: true,
        showCancelButton:true,
      }).then((result) => {
        if (result.value) {
          axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
          axios.get(process.env.VUE_APP_API_BASEURL+'customer/add_cron_cust/'+this.id_order)
          .then(response => {
            console.log('send succes email', response.data);
              if (response) {
                  this.loadingData=false;
                  if(response.data.status == "success"){
                    Swal.fire({
                      title: 'Added to cron',
                      icon: 'success',
                      showConfirmButton: false,
                    });
                  }else{
                    Swal.fire({
                      // title: 'Something Wrong',
                      text:   response.data.msj,
                      icon: 'error',
                      showConfirmButton: false,
                    });
                  }
              
              } 
              else {
                  this.messageBag = ['Error'];
              }
          })
          .catch(error => {
              this.messageBag = [error.error];
          }); 
        }
      });
    },
    send_email_success_store(){


      Swal.fire({
        title: 'Are you sure want to add cron for store success?',
        icon: 'warning',
        showConfirmButton: true,
        showCancelButton:true,
      }).then((result) => {
        if (result.value) {

          axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
          axios.get(process.env.VUE_APP_API_BASEURL+'customer/add_cron_store/'+this.id_order)
          .then(response => {
            console.log('send succes email', response.data);
              if (response) {
                  this.loadingData=false;
                  if(response.data.status == "success"){
                    Swal.fire({
                      title: 'Added to cron',
                      icon: 'success',
                      showConfirmButton: false,
                    });
                  }else{
                    Swal.fire({
                      title: response.data.msj,
                      icon: 'error',
                      showConfirmButton: false,
                    });
                  }
              
              } 
              else {
                  this.messageBag = ['Error'];
              }
          })
          .catch(error => {
              this.messageBag = [error.error];
          }); 
        }
      });
    },

    request_credit_check(){
      this.retry = this.retry +1;
      this.loadingCreditCheck = true;
      setTimeout(()=>this.checkingpopup());              
      var posting_ = {};

        posting_ = {                
            orderId: this.id_order,
            customerId: this.$route.params.cid,
            net_salary: this.net_salary,
        };

      axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
      axios.post(process.env.VUE_APP_API_BASEURL+'applications/v1/credit-check/customer-service',posting_)
      .then(response => {
      this.loadingCreditCheck = true;
      if (response){
        this.get_customer_by_id();

        
        if(response.data.status == true){
            this.credit_check_result = 'approved';
            this.creditCheckNotActive = true;
            
            Swal.fire({
                title: response.data.msj,
                icon: 'success',
                timer: 20500,
                showConfirmButton: true,
            });
        }
        else {
            this.creditCheckNotActive = false;
            this.credit_check_result = 'Timeout';
            // this.creditCheckFailed = true;
            Swal.fire({
                title: ' Credit check Failed !',
                text:   response.data.msj,
                icon: 'error',
                showConfirmButton: true,
            });    
        }

      } else {
            this.creditCheckNotActive = false;
            this.credit_check_result = 'Timeout';
            // this.creditCheckFailed = true;
            Swal.fire({
                title: ' Credit check Failed !',
                text:   response.data.msj,
                icon: 'error',
                showConfirmButton: true,
            });    
        }
    }).catch(error => {
    this.messageBag = [error.error];
    });


    },

    checkingpopup(){
      Swal.fire({
          title: 'Performing credit check...',
          text:  'Please wait',
          icon: 'warning',
          showConfirmButton: false,
      }); 
    },

    //raw data----------------------------------------------------------
    get_order_status(){
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.get(process.env.VUE_APP_API_BASEURL+'orderstatus/list')
        .then(response => {
            if (response) {
                this.orderstatusList = response.data;
                console.log(this.orderstatusList);
            } 
            else {
                this.messageBag = ['No record.'];
            }
        })
        .catch(error => {
            this.messageBag = [error.error];
        });
    },

    get_customer_by_id_temp(){
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.get(process.env.VUE_APP_API_BASEURL+'customer/order_details_temp_id/'+this.nric_num)
        .then(response => {
          
            if (response) {
              this.customer_order_info_temp = response.data; 
              this.dropoff_temp = this.customer_order_info_temp.dropoff;
            }
        })
        .catch(error => {
            this.messageBag = [error.error];
        });
    },
    //raw data----------------------------------------------------------

    async updateReferral() {
      try {
        const posting_ = {                
            referer_code: this.referer_code,
        };
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.post(process.env.VUE_APP_API_BASEURL+'customer/update/referral/'+this.$route.params.cid, posting_)
        .then(response => {
            if (response.data.message) {
              alert(response.data.message);
            }
          })
      } catch (error) {
        console.error('Failed to update referral.', error);
        alert('Failed to update referral.');
      }
    },
    urlUploadEPF(){
      this.UploadEPFLinkURL = process.env.VUE_APP_RENEWNGO_WEBCLIENT_HOST+'/applications/upload-documents?temporary_id='+this.temp_id+'&hash='+this.hash;
    }
  },

  

  components: {
      Layout,
      PageHeader,
      Select2, 
      //DataTable,
  },

  mounted() {     
      this.get_customer_by_id();  
      this.get_order_status();        
      this.get_customer_mandate_sts();        
      this.get_customer_instantpay_sts();  
      this.getBranchForDelivery();  
      this.GetCollectionData();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header border-0">
              <h3><i class="ri-function-fill text-muted align-bottom me-1"></i>{{ namepernric }}</h3>
          </div>
          <hr class="my-1 text-muted">
                <div class="row">
                  <div class="col-xl-6">
                    <div class="card">
                      <div class="card-header">
                        <div class="d-flex align-items-center">
                          <h5>Order Details</h5>
                        </div>
                      </div>
                      <div class="card-body">
                        <div class="live-preview">
                          <form @submit="update_customer_order">
                            <div class="row mb-3">
                              <div class="col-lg-3">
                                <label for="order_no" class="form-label">Order Number</label>
                              </div>
                              <div class="col-lg-9">
                                <input v-model='order_no' type="text" class="form-control" id="order_no" readonly/>
                              </div>
                            </div>
                            <div class="row mb-3">
                              <div class="col-lg-3">
                                <label for="created_at" class="form-label">Order Date</label>
                              </div>
                              <div class="col-lg-9">
                                <input v-model='created_at' type="text" class="form-control" id="created_at" readonly/>
                              </div>
                            </div>
                            <div class="row mb-3">
                              <div class="col-lg-3">
                                <label for="customer_full_name" class="form-label">Customer Name</label>
                              </div>
                              <div class="col-lg-9">
                                <a v-bind:href="'/customer/customer-details/'+ customer_id" target="_blank" rel="noreferrer noopener">{{ namepernric }}</a>
                                <!--input v-model='customer_full_name' type="text" class="form-control" id="customer_full_name" readonly/-->
                              </div>
                            </div>
                            <div class="row mb-3">
                              <div class="col-lg-3">
                                <label for="salary" class="form-label">Status</label>
                              </div>
                              <div class="col-lg-9">
                          <select 
                            v-model="order_status_id" 
                            class="form-select mb-3" 
                            aria-label="Default select example" 
                            :disabled="permissions.canApprove?.value === false && (order_status_id === 1 || order_status_id === 2)">
                            <option v-for="(item, index) in orderstatusList" :key="index" :value="item.id">
                              {{ item.name }}
                            </option>
                          </select>
                              </div>
                            </div>
                            <div class="row mb-3">
                              <div class="col-lg-3">
                                <label for="data_verification" class="form-label">Data Verification</label>
                              </div>
                              <div class="col-lg-9">
                                <select v-model="data_verification" class="form-select mb-3" arial-label="Default select example" placeholder="Enter Price For Country" required>
                                    <option value="1">
                                        Completed
                                    </option>
                                    <option value="0">
                                        Not Completed
                                    </option>
                                    <option value="2">
                                        Failed
                                    </option>
                                </select>
                              </div>
                            </div>
                            <div class="row mb-3">
                              <div class="col-lg-3">
                                <label for="gender" class="form-label">Call Verification</label>
                              </div>
                              <div class="col-lg-9">
                                <select v-model="call_verification" class="form-select mb-3" arial-label="Default select example" placeholder="Enter Price For Country" required>
                                    <option value="1">
                                        Completed
                                    </option>
                                    <option value="0">
                                        Not Completed
                                    </option>
                                    <option value="2">
                                        Failed
                                    </option>
                                </select>
                              </div>
                            </div>
                            <div class="row mb-3">
                              <div class="col-lg-3">
                                <label for="created_at" class="form-label">Straight Through</label>
                              </div>
                              <div class="col-lg-9">
                                <input v-model='straight_through' type="text" class="form-control" id="straight_through" readonly/>
                              </div>
                            </div>
                            <div class="row mb-3">
                              <div class="col-lg-3">
                                <label for="remarks" class="form-label">Remarks</label>
                              </div>
                              <div class="col-lg-9">
                                <textarea v-model="remarks" rows="4" class="form-control" id="remarks" ></textarea>
                              </div>
                            </div>
                            <div class="text-end col-lg-12">
                              <button v-if="permissions.canUpdate?.value" type="submit" class="btn btn-primary">
                                Update
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>        
                  </div>

                  <!--Payment History ------------------------------------>
                  <div class="col-xl-6">    
                    <div class="card">
                      <form @submit="update_customer_program_detail">
                      <div class="card-header">
                        <div class="d-flex align-items-center">
                          <h5>Program Details</h5>
                        </div>
                      </div>
                      <div class="card-body">
                        <div class="live-preview">
                          <div class="row align-items-center g-12">                           
                              <div class="col-lg-12">
                                  <div class="row mb-3">
                                    <div class="col-lg-3">
                                      <label for="program_name" class="form-label">Program</label>
                                    </div>
                                    <div class="col-lg-9">
                                      <input v-model='program_name' type="text" class="form-control" id="program_name" readonly/>
                                    </div>
                                </div>
                                <div v-if="order_for !== 'DLC-eCOMM' && order_for !== 'DLCCA2'" class="row mb-3">
                                    <div class="col-lg-3">
                                      <label for="pickup_store" class="form-label">Pickup Store</label>
                                    </div>
                                    <!-- <div class="col-lg-9">
                                      <input v-model='pickup_store' type="text" class="form-control" id="pickup_store" readonly/>
                                    </div> -->
                                  <div class="col-sm-9">
                                    <Select2 v-model="pickup_store" :options="branchList"></Select2>
                                  </div>
                                </div>
                                <div class="row mb-3">
                                  <div class="col-lg-3">
                                    <label for="program_fee" class="form-label">Program Fee</label>
                                  </div>
                                  <div class="col-lg-9">
                                    <input v-model='program_fee' type="text" class="form-control" id="program_fee" readonly/>
                                  </div>
                                </div>
                                <div class="row mb-3">
                                  <div class="col-lg-3">
                                    <label for="product_name" class="form-label">Device Name</label>
                                  </div>
                                  <div class="col-lg-9">
                                    <input v-model='product_name' type="text" class="form-control" id="product_name" readonly/>
                                  </div>
                                </div>
                                
                                <div class="row mb-3">
                                  <div class="col-lg-3">
                                    <label for="product_name" class="form-label">Color</label>
                                  </div>
                                  <div class="col-lg-9">
                                    <select v-model="sku" class="form-select mb-3" arial-label="Default select example" placeholder="Enter Select Color">
                                        <option v-for="(item, index) in listColor" :key="index" :value="item.sku" >
                                            {{ item.name }}
                                        </option>
                                  </select>
                                  </div>
                                </div>
                                
                                <div class="row mb-3">
                                  <div class="col-lg-3">
                                    <label for="sku" class="form-label">SKU</label>
                                  </div>
                                  <div class="col-lg-9">
                                    <input v-model='sku' type="text" class="form-control" id="sku" readonly/>
                                  </div>
                                </div>
                                <div class="row mb-3">
                                  <div class="col-lg-3">
                                    <label for="salary" class="form-label">Price</label>
                                  </div>
                                  <div class="col-lg-9">
                                    <input v-model='price' type="text" class="form-control" id="price" readonly/>
                                  </div>
                                </div>
                                <div v-if = "knockOffAmount < 0" class="row mb-3">
                                  <div class="col-lg-3">
                                    <label for="salary" class="form-label">Security Deposit Offset</label>
                                  </div>
                                  <div class="col-lg-9">
                                    <input v-model='knockOffAmount' type="text" class="form-control" id="price" readonly/>
                                  </div>
                                </div>
                                <div v-if = "knockOffAmount < 0" class="row mb-3">
                                  <div class="col-lg-3">
                                    <label for="salary" class="form-label">New Monthly Price</label>
                                  </div>
                                  <div class="col-lg-9">
                                    <input v-model='newlyMonthlyAmount' type="text" class="form-control" id="price" readonly/>
                                  </div>
                                </div>
                                <div v-if = "knockOffAmount < 0" class="row mb-3">
                                  <div class="col-lg-3">
                                    <label for="salary" class="form-label">Total Security Deposit</label>
                                  </div>
                                  <div class="col-lg-9">
                                    <input v-model='securityDeposit' type="text" class="form-control" id="price" readonly/>
                                  </div>
                                </div>
                                <div class="row mb-3">
                                  <div class="col-lg-3">
                                    <label for="salary" class="form-label">Tenure</label>
                                  </div>
                                  <div class="col-lg-9">
                                    <input v-model='tenure' type="text" class="form-control" id="price" readonly/>
                                  </div>
                                </div>
                                <div class="text-end col-lg-12">
                                  <button v-if="permissions.canUpdate?.value" type="submit" class="btn btn-primary" :disabled='buttonskudisable'>
                                    Update
                                  </button>
                                </div>
                              </div>
                          </div>
                        </div>
                     
                      </div>
                    </form>
                    </div>
                    <div class="card">
                      <div class="card-header">
                        <div class="d-flex align-items-center">
                          <h5>Delivery Information</h5>
                        </div>
                      </div>
                      <form @submit="update_ecom_delivery">
                        <div class="card-body">
                        <div class="live-preview">
                          <div class="row align-items-center g-12">                           
                              <div class="col-lg-12">
                                  <div class="row mb-3">
                                    <div class="col-lg-3">
                                      <label for="program_name" class="form-label">Delivery Option</label>
                                    </div>
                                    <div class="col-lg-9">
                                      <!-- <input v-model='delivery_option' type="text" class="form-control" id="program_name" readonly/> -->
                                      <select v-model="delivery_option" class="form-select mb-3" arial-label="Default select example" placeholder="Enter Price For Country">
                                            <option value="">Please Select Delivery Option</option>
                                            <option value="delivery">Delivery</option>
                                            <option value="pickup">Pickup</option>
                                      </select>
                                    </div>
                                </div>
                                <div v-if="delivery_option == 'delivery'" class="row mb-3">

                                  <label for="placeholderInput" class="form-label " style="font-size: 20px;">Delivery Address</label>
                                      <div class="col-md-6">                                               
                                          <label for="placeholderInput" class="form-label">Zip/Postal<span style="color: red;">*</span></label>
                                          <div class="input-group">
                                              <input type="text" class="form-control" v-model="delivery_postcode" v-on:keypress="NumbersOnly" maxlength="5" aria-label="Recipient's username with two button addons">
                                          </div>                                               
                                      </div>

                                      <div class="col-md-6">                                               
                                          <label for="placeholderInput" class="form-label"> City<span style="color: red;">*</span></label>
                                          <div class="input-group">
                                              <input type="text" class="form-control" v-model="delivery_city" aria-label="Recipient's username with two button addons">
                                          </div>                                               
                                      </div>
                                      <div class="col-md-6">                                                   
                                          <label for="placeholderInput" class="form-label"> State<span style="color: red;">*</span></label>
                                          <div class="input-group">
                                              <select v-model="delivery_state_id" class="form-select mb-3" arial-label="Default select example" placeholder="Enter Price For Country">
                                                  <option disabled value="">Please Select State</option>
                                                  <option value="4">Selangor</option>
                                                  <option value="15">Wilayah Persekutuan</option>
                                                  <option value="16">Putrajaya</option>
                                                  <option value="7">Pulau Pinang</option>
                                                  <option value="3">Negeri Sembilan</option>
                                                  <option value="1">Johor</option>
                                                  <option value="2">Melaka</option>
                                                  <option value="5">Perak</option>
                                                  <option value="6">Kedah</option>
                                                  <option value="9">Perlis</option>
                                                  <option value="10">Kelantan</option>
                                                  <option value="11">Terengganu</option>
                                                  <option value="12">Pahang</option>
                                            </select>
                                          </div>                                                    
                                      </div>
                                      <div class="col-md-6">
                                          <label for="placeholderInput" class="form-label"> Country<span style="color: red;">*</span></label>
                                          <div class="input-group">
                                              <select v-model="country" class="form-select mb-3" arial-label="Default select example" placeholder="Enter Price For Country" disabled>
                                                  <option value="1" >
                                                      Malaysia
                                                  </option>
                                              </select>
                                          </div>                                                   
                                      </div>
                                      <div class="row col-md-12">
                                        <div class="col-lg-9">
                                        <label for="pickup_store" class="form-label">Delivery Address</label>
                                        </div>
                                        <div class="col-lg-9">
                                          <textarea v-model='delivery_address' type="text" class="form-control" id="pickup_store"/>
                                        </div>
                                      </div>
                                 
                                </div>
                                <div v-else-if="delivery_option == 'pickup'" class="row mb-3">
                                  <div class="col-lg-3">
                                    <label for="pickup_store" class="form-label">Change Pickup Store</label>
                                  </div>
                                  <div class="col-lg-9">
                                    <select v-model="pickupbranch" class="form-select mb-3" arial-label="Default select example" placeholder="Enter Price For Country">
                                      <option value="">Please Select Pickup Branch</option>
                                      <option v-for="(item, index) in branchListPickup" :key="index" :value="item.id" >{{ item.name }}</option>
                                   </select>
                                  
                                  </div>
                                  <div class="col-lg-3">
                                    <label for="pickup_store" class="form-label">Pickup Store</label>
                                  </div>
                                  <div class="col-lg-9">
                                    <textarea v-model='pickup_store_address' type="text" class="form-control" id="pickup_store" readonly/>
                                  </div>
                   
                                </div>
                                <div v-else class="row mb-3">
                                
                                  <div class="col-lg-3">
                                    <label for="pickup_store" class="form-label">Pickup Store</label>
                                  </div>
                                  <div class="col-lg-9">
                                    <textarea type="text" class="form-control" id="pickup_store" readonly/>
                                  </div>
                                 
                                </div>
                                <div class="text-end col-lg-12">
                                  <button v-if="permissions.canUpdate?.value" type="submit" class="btn btn-primary" :disabled="(has_house_delivery == '1') ? false : true">
                                    Update
                                  </button>
                                </div>
                              </div>
                          </div>
                        </div>
                      </div>
                      </form>
                      
                    </div>



                  </div>
                </div>
                <div class="row">
                  <!--Payment Details------------------------------------->
                  <div class="col-xl-6">    
                    <div class="card">
                      <div class="card-header">
                        <div class="d-flex align-items-center">
                          <h5>Payment Details</h5>
                        </div>
                      </div>
                      <div class="card-body">
                        <div class="live-preview">
                          <div class="row align-items-center g-12">                           
                              <div class="col-lg-12">
                                  <div class="row mb-3">
                                    <div class="col-lg-3">
                                      <label for="curlec_reference_no" class="form-label">Reference No</label>
                                    </div>
                                    <div class="col-lg-9">
                                      <input v-model='curlec_reference_no' type="text" class="form-control" id="curlec_reference_no" readonly/>
                                    </div>
                                  </div>
                                  <div class="row mb-3">
                                    <div class="col-lg-3">
                                      <label for="mandate_status" class="form-label">eMandate Payment Status</label>
                                    </div>
                                    <div class="col-lg-9">
                                      <input v-model='mandate_status' type="text" class="form-control" id="mandate_status" readonly/>
                                    </div>
                                  </div>
                                  <div class="row mb-3">
                                    <div class="col-lg-3">
                                      <label for="cancel_reason" class="form-label">Upfront Payment Status</label>
                                    </div>
                                    <div class="col-lg-9">
                                      <input v-model='instantpay_status' type="text" class="form-control" id="instantpay_status" readonly/>
                                    </div>
                                  </div>
                                  <div class="row mb-3">
                                    <div class="col-lg-3">
                                      <label for="cancel_reason" class="form-label">Upfront Payment Date</label>
                                    </div>
                                    <div class="col-lg-9">
                                      <input :value="formatDateToWeb(upfrontPaymentDate, 'DD-MMM-YYYY')" type="text" class="form-control" id="upfrontPaymentDate" readonly/>
                                    </div>
                                  </div>
                                  <div class="row mb-3">
                                    <div class="col-lg-3">
                                      <label for="cancel_reason" class="form-label">Cancel Reason</label>
                                    </div>
                                    <div class="col-lg-9">
                                      <textarea v-model="cancel_reason" rows="4" class="form-control" id="cancel_reason" disabled></textarea>
                                    </div>
                                  </div>
                                  <div class="row mb-3" v-if="order_status_id == 10">
                                    <div class="col-lg-3">
                                      <label for="payment_link" class="form-label">Upload EPF Link</label>
                                    </div>
                                    <div class="col-lg-9">
                                      <input v-model='UploadEPFLinkURL' type="text" class="form-control" id="payment_link" readonly/>
                                    </div>
                                  </div>
                                  <div class="row mb-3">
                                    <div class="col-lg-3">
                                      <label for="payment_link" class="form-label">Payment Link</label>
                                    </div>
                                    <div class="col-lg-9">
                                      <input v-model='payment_link' type="text" class="form-control" id="payment_link" readonly/>
                                    </div>
                                  </div>
                                  <div class="mb-3 text-end col-lg-12">
                                    <button v-if="permissions.canCreate?.value" :disabled="disableGeneratePaymentLink" @click="generate_payment_link()" class="btn btn-success">Generate Payment Link</button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                  </div>
                                  <div class="row mb-3">
                                    <div class="col-lg-3">
                                      <label for="email_address" class="form-label">Email Address</label>
                                    </div>
                                    <div class="col-lg-9">
                                      <input v-model='email_address' type="text" class="form-control" id="email_address" readonly />
                                    </div>
                                  </div>
                                  <div class="row mb-3">
                                    <div class="col-lg-3">
                                      <label for="credit_check_request_by" class="form-label">Request By</label>
                                    </div>
                                    <div class="col-lg-9">
                                      <input v-model='credit_check_request_by' type="text" class="form-control" id="credit_check_request_by" readonly/>
                                    </div>
                                  </div>
                                  <div class="row mb-3">
                                    <div class="col-lg-3">
                                      <label for="email_status" class="form-label">Email Status</label>
                                    </div>
                                    <div class="col-lg-9">
                                      <input v-model='email_status' type="text" class="form-control" id="email_status" readonly />
                                    </div>
                                  </div>
                                  <div class="text-end col-lg-12">
                                    <button v-if="permissions.canCreate?.value" :disabled="disableSendEmail" @click="send_email()" class="btn btn-success">Send Email</button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                  </div>
                              </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!--Credit Check Details--------------------------------->
                <div class="col-xl-6">    
                    <div class="card">
                      <div class="card-header">
                        <div class="d-flex align-items-center">
                          <h5>Credit Check Details</h5>
                        </div>
                      </div>
                      <div class="card-body">
                        <div class="live-preview">
                          <div class="row align-items-center g-12">                           
                              <div class="col-lg-12">
                                <div class="row mb-3">
                                  <div class="col-lg-3">
                                    <label for="credit_check_result" class="form-label">Credit Check Status</label>
                                  </div>
                                  <div class="col-lg-9">
                                    <input v-model='credit_check_result' type="text" class="form-control" id="credit_check_result" readonly/>
                                  </div>
                                </div>
                                <div class="row mb-3">
                                  <div class="col-lg-3">
                                    <label for="credit_check_real" class="form-label">Request By</label>
                                  </div>
                                  <div class="col-lg-9">
                                    <input v-model='credit_check_real' type="text" class="form-control" id="credit_check_real" readonly/>
                                  </div>
                                </div>
                                <div class="row mb-3">
                                  <div class="col-lg-3">
                                    <label for="credit_check_request_datetime" class="form-label">Request Datetime</label>
                                  </div>
                                  <div class="col-lg-9">
                                    <input v-model='credit_check_request_datetime' type="text" class="form-control" id="credit_check_request_datetime" readonly/>
                                  </div>
                                </div>
                                <div class="text-end col-lg-12">
                                    <button v-if="permissions.canUpdate?.value" :disabled="creditCheckNotActive" @click="request_credit_check()" class="btn btn-success">Request Credit Check</button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                  </div>
                              </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="card">
                      <div class="card-header">
                        <div class="d-flex align-items-center">
                          <h5>Dropoff</h5>
                        </div>
                      </div>
                      <div class="card-body">
                        <div class="live-preview">
                          <div class="row align-items-center g-12">                           
                              <div class="col-lg-12">
                                <div class="row mb-3">
                                  <div class="col-lg-3">
                                    <label for="credit_check_result" class="form-label">Page</label>
                                  </div>
                                  <div class="col-lg-9">
                                    <input  v-if='this.dropoff_cust != null' v-model='dropoff_cust' type="text" class="form-control" id="credit_check_result" readonly/>
                                    <input v-else v-model='dropoff_temp' type="text" class="form-control" id="credit_check_result" readonly/>

                                  </div>
                                </div>
                              </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="card">
                      <div class="card-header">
                        <div class="d-flex align-items-center">
                          <h5>Send Email</h5>
                        </div>
                      </div>
                      <div class="card-body">
                        <div class="live-preview">
                          <div class="row align-items-center g-12">                           
                              <div class="col-lg-12">
                                <div class="row mb-3">
                                  <div class="col-lg-3">
                                    <label for="credit_check_result" class="form-label"></label>
                                  </div>
                                  <div class="col-lg-4">

                                    <button v-if="permissions.canUpdate?.value" @click="send_email_success_cust()" class="btn btn-success" :disabled='emailconfirm'>Send Email Confirmation Customer</button> 

                                  </div>
                                  <div class="col-lg-4">
                                    <button v-if="permissions.canUpdate?.value" @click="send_email_success_store()" class="btn btn-success" :disabled='emailconfirm'>Send Email Confirmation Store</button>
                                  </div>
                                </div>
                              </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <div class="card">
                      <div class="card-header">
                        <div class="d-flex align-items-center">
                          <h5></h5>
                        </div>
                      </div>
                      <div class="card-body">
                        <div class="live-preview">
                          <div class="row align-items-center g-12"> 
                              <form @submit.prevent="updateReferral">
                                <div class="col-lg-12">
                                  
                                  <div  class="row mb-3">
                                      <div class="col-lg-3">
                                        <label for="referer_code" class="form-label">Referral / Promo Code</label>
                                      </div>
                                      <div class="col-lg-9">
                                        <textarea v-model='referer_code' type="text" class="form-control" id="referer_code" />
                                      </div>
                                      
                                  </div>
                                  <div class="text-end col-lg-12">
                                    <button v-if="permissions.canUpdate?.value" class="btn btn-success">Edit Referral</button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                  </div>
                                </div>
                              </form>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="text-end col-lg-12">
                    <a @click="$router.go(-1)" class="btn btn-success">Back</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </div>

                  </div>


                </div>
              
           
            <!--end tab-content-->
    
          <!--end card-body-->
        </div>
        
        <!--end card -->
      </div>
      
      <!--end card -->
    </div>
    
    <!--end row-->
  </Layout>
</template>